export default "__VITE_ASSET__mpV_Vo0$__"